module.exports = __webpack_public_path__ + "assets/img/order-count-icon3.7565c4ef.png";